// https://icons8.com/icon/set/home/sf-regular

const regularIcons = {
  home: 'sf-regular/home.png',
  payments: 'sf-regular/bank-cards.png',
  clone: 'sf-regular/documents.png',
  phone: 'sf-regular/phone.png',
  email: 'sf-regular/secured-letter.png',
  sms: 'sf-regular/sms.png',
  dots: 'sf-regular/more.png',
  dotsVertical: 'material-rounded/menu-2.png',
  birthday: 'sf-regular/birthday.png',
  location: 'sf-regular/address.png',
  locations: 'sf-regular/address.png',
  mapLocation: 'sf-regular/address.png',
  directions: 'sf-regular/near-me.png',
  delete: 'sf-regular/delete.png',
  consultationForm: 'sf-regular/treatment-plan.png',
  forward: 'sf-regular/forward.png',
  arrowUpward: 'sf-regular/collapse-arrow.png',
  arrowDownward: 'sf-regular/expand-arrow.png',
  back: 'sf-regular/back.png',
  calendar: 'sf-regular/calendar.png',
  calendarPlus: 'sf-regular/calendar-plus.png',
  block: 'sf-regular/cancel-2.png',
  cancellation: 'sf-regular/multiply.png',
  unblock: 'sf-regular/ok.png',
  cancel: 'sf-regular/multiply.png',
  x: 'sf-regular/multiply.png',
  discountTicket: 'sf-regular/discount-ticket.png',
  externalPromocode: 'sf-regular/discount-ticket.png',
  promocode: 'sf-regular/discount-ticket.png',
  contacts: 'sf-regular/contacts.png',
  profile: 'windows/user-male-circle.png',
  hashtag: 'sf-regular/hashtag.png',
  future: 'sf-regular/future.png',
  passFail: 'sf-regular/test-partial-passed.png',
  edit: 'sf-regular/create-new.png',
  bookingSystem: 'sf-regular/overtime.png',
  shop: 'sf-regular/shop.png',
  treatments: 'sf-regular/water.png',
  add: 'sf-regular/plus.png',
  treatmentLibrary: 'sf-regular/lotus.png',
  settings: 'sf-regular/settings.png',
  key: 'sf-regular/key.png',
  voucher: 'sf-regular/discount-ticket.png',
  clock: 'sf-regular/clock.png',
  exclamation: 'sf-regular/box-important.png',
  exclamationFilled: 'sf-regular-filled/box-important.png',
  tick: 'sf-regular/ok.png',
  checkmark: 'sf-regular/checkmark.png',
  check: 'sf-regular/ok.png',
  checkFilled: 'sf-regular-filled/ok.png',
  uncheckedBox: 'sf-regular/unchecked-checkbox.png',
  checkedBox: 'sf-regular-filled/checked-checkbox.png',
  bookings: 'sf-regular/copybook.png',
  filter: 'sf-regular/sorting-options.png',
  refund: 'sf-regular/refund-2.png',
  none: 'sf-regular/cancel-2.png',
  plusMath: 'sf-regular/plus-math.png',
  event: 'sf-regular/today.png',
  showProperty: 'sf-regular/show-property.png',
  elite: 'sf-regular/diamond.png',
  instant: 'sf-regular/lightning-bolt.png',
  minusMath: 'sf-regular/minus-math.png',
  share: 'sf-regular/share.png',
  rebook: 'sf-regular/overtime.png',
  list: 'sf-regular/list.png',
  dev: 'sf-regular/test-tube.png',
  noShow: 'sf-regular/remove-user-male.png',
  restore: 'sf-regular/repeat.png',
  reschedule: 'sf-regular/repeat.png',
  information: 'sf-regular-filled/info.png',
  copy: 'sf-regular/copy.png',
  deposit: 'sf-regular/refund.png',
  consultationFormSection: 'sf-regular/survey.png',
  notifications: 'sf-regular/appointment-reminders.png',
  notes: 'sf-regular/notepad.png',
  clients: 'sf-regular/contacts.png',
  team: 'sf-regular/group-foreground-selected.png',
  creditCard: 'sf-regular/bank-card-back-side.png',
  info: 'sf-regular/info.png',
  help: 'sf-regular/info.png', // Duplicate of info icon, aligns with PA icon name
  contactless: 'sf-regular/nfc-checkpoint.png',
  gift: 'sf-regular/gift.png',
  qr: 'sf-regular/qr-code.png',
  car: 'sf-regular-filled/car.png',
  circleOutline: 'sf-regular/circled.png',
  circleFilled: 'sf-regular/filled-circle.png',
  search: 'sf-regular/search.png',
  expandArrow: 'sf-regular/expand-arrow.png',
  warning: 'sf-regular/box-important.png',
  marketing: 'sf-regular/commercial.png',
  emailBroadcast: 'sf-regular/message-group.png',
  smsBroadcast: 'sf-regular/push-notifications.png',
  automatedMessaging: 'sf-regular/messaging-.png',
  website: 'sf-regular/template.png',
  community: 'sf-regular-filled/conference-call.png',
  chats: 'sf-regular/chat.png',
  instantBolt: 'sf-regular/lightning-bolt.png',
  import: 'sf-regular/import.png',
  globe: 'sf-regular/geography.png',
  refresh: 'sf-regular/available-updates.png',
  document: 'sf-regular/overview-pages-1.png',
  todo: 'sf-regular/todo-list.png',
  arrowRightUp: 'sf-regular/right.png', // The angle is handled in the Icon8 component
  schedule: 'sf-regular/overtime.png',
  duration: 'sf-regular/time-machine.png',
  aftercare: 'sf-regular/info.png',
  terms: 'sf-regular/agreement.png',
  noConnection: 'sf-regular/wi-fi-disconnected.png',
  approval: 'sf-regular/approval.png',
  exit: 'sf-regular/exit.png',
  star: 'sf-regular-filled/star.png',
  squareFilled: 'sf-regular-filled/stop.png',
  square: 'sf-regular/stop.png',
  newClient: 'sf-regular/add-user-male.png',
  existingClient: 'sf-regular/group-foreground-selected.png',
  askQuestion: 'sf-regular/ask-question.png',
  send: 'sf-regular/sent.png',
  font: 'ios/align-cell-content-left.png',
  text: 'ios/align-left.png',
  button: 'ios/button2.png',
  image: 'sf-regular/image.png',
  horizontalLine: 'sf-regular/horizontal-line.png',
  desktop: 'sf-regular/monitor.png',
  mobile: 'sf-regular/smartphone.png',
  burgerMenu: 'sf-regular/menu.png',
  connection: 'sf-regular/high-connection.png',
  reload: 'sf-regular/recurring-appointment.png',
  theme: 'sf-regular/roller-brush.png',
  lookBook: 'sf-regular/stack-of-photos.png',
  pinnedReview: 'sf-regular/rating.png',
  starOutline: 'sf-regular/star.png',
  cancelPolicy: 'sf-regular/cancel-subscription.png',
  invoices: 'sf-regular/purchase-order.png',
  income: 'sf-regular/doughnut-chart.png',
  logs: 'sf-regular/todo-list.png',
  cash: 'sf-regular/money.png',
  bank: 'sf-regular/merchant-account.png',
  machine: 'material-two-tone/contactless-payment.png',
  other: 'sf-regular/cash-register.png',
  permissions: 'sf-regular/user-credentials.png',
  depositSettings: 'sf-regular/card-in-use.png',
  banner: 'sf-regular/panorama.png',
  crop: 'material-rounded/crop.png',
  reward: 'sf-regular/prize.png',
  googleLogo: 'sf-regular/google-logo.png',
  paintBrush: 'sf-regular/paint-brush.png',
  notification: 'sf-regular/push-notifications.png',
  ai: 'ios-filled/sparkling.png',
  importData: 'ios-glyphs/back-sorting.png',
  archive: 'sf-regular/downloading-updates.png',
  actionButton: 'sf-regular/play-button-circled.png',
  treatmentList: 'sf-regular/survey.png',
  chart: 'sf-regular/bullish.png',
  question: 'sf-regular/help.png',
  connected: 'sf-regular/connected.png',
  statistics: 'sf-regular/statistics.png',
  pin: 'sf-regular/pin.png',
  averageBooking: 'sf-regular/check.png',
  copyLink: 'sf-regular/copy-link.png',
  logoList: 'sf-regular/price-tag.png',
  priceTag: 'sf-regular/price-tag.png',
  // These icons use snake_case to match API responses
  gift_card: 'sf-regular/discount-ticket.png',
  gift_card_refund: 'sf-regular/discount-ticket.png',
  //These icons are duplicates to match PA icon names
  smsIcon: 'sf-regular/sms.png',
  promote: 'sf-regular/commercial.png',
  availability: 'sf-regular/clock.png',
  newAccountBadge: 'ios-filled/sparkling.png',
  rewards: 'ios-filled/sparkling.png',
  google: 'sf-regular/google-logo.png',
  adventures: 'sf-regular/adventures.png',
  webDesign: 'sf-regular/web-design.png',
  web: 'sf-regular/web-design.png',
  searchProperty: 'sf-regular/show-property.png',
  writeReview: 'sf-regular/rating.png',
  growthHub: 'sf-regular/sprout.png',
  whatsApp: 'sf-regular/whatsapp.png',
  broadcastEmails: 'sf-regular/message-group.png',
  walkIn: 'sf-regular/barber-chair.png',
  backspace: 'material-outlined/clear-symbol--v1.png',
  serviceProvider: 'sf-regular/overtime.png',

  // Website icons
  pointer: 'sf-regular/one-finger.png',
  layout: 'sf-regular/medium-icons.png',
  reviews: 'sf-regular/rating.png',
  wand: 'sf-regular/fantasy.png',
  brush: 'sf-regular/paint-brush.png',
  tablet: 'sf-regular/ipad.png',
  business: 'sf-regular/business.png',
  externalLink: 'sf-regular/external-link.png',
  eyeOff: 'sf-regular/invisible.png',
  positionArrows: 'sf-regular/sorting-arrows.png',

  uncheckedBoxV2: 'ios/unchecked-checkbox.png',
  checkedBoxV2: 'ios-filled/checked-checkbox.png',

  undo: 'material-rounded/undo.png',
  redo: 'material-rounded/redo.png',

  googleMyBusiness: 'color/my-bussiness.png',
  verifiedCheck: 'color/verified-account--v1.png',

  reply: 'sf-regular-filled/reply-arrow.png',
}

const smallIcons = {
  smForward: 'sf-black/forward.png',
  smRepeat: 'sf-black/refresh.png',
  smCalendar: 'sf-black/planner.png',
  smExpandArrow: 'sf-black/expand-arrow.png',
  smTick: 'sf-black/checkmark.png',
  smDoubleTick: 'local/custom-doubleTick.svg',
  smDoubleChevron: 'sf-regular/double-right.png',
  smPlus: 'sf-black/plus-math.png',
  smAddCircle: 'sf-regular/add.png',
  smPound: 'material-rounded/british-pound.png',
  smExclamation: 'sf-regular-filled/exclamation-mark.png',
  smCross: 'sf-black/multiply.png',
  smPortal: 'sf-black/geography.png',
  smUndo: 'sf-black/undo.png',
  smDots: 'sf-black/more.png',
  smClock: 'sf-black/clock.png',
  loyalty: 'sf-regular/starred-ticket.png',
  referral: 'sf-regular/gift.png',
  idea: 'sf-regular/light-on.png',
}

const specialIcons = {
  loadingSpinner: 'fluency-systems-filled/iphone-spinner.png',
  dropDownArrow: 'material-rounded/expand-arrow--v1.png',
  photoGallery: 'sf-regular/stack-of-photos.png',
}

const calendarIcons = {
  calendar1: 'sf-regular/calendar-1.png',
  calendar2: 'sf-regular/calendar-2.png',
  calendar3: 'sf-regular/calendar-3.png',
  calendar4: 'sf-regular/calendar-4.png',
  calendar5: 'sf-regular/calendar-5.png',
  calendar6: 'sf-regular/calendar-6.png',
  calendar7: 'sf-regular/calendar-7.png',
  calendar8: 'sf-regular/calendar-8.png',
  calendar9: 'sf-regular/calendar-9.png',
  calendar10: 'sf-regular/calendar-10.png',
  calendar11: 'sf-regular/calendar-11.png',
  calendar12: 'sf-regular/calendar-12.png',
  calendar13: 'sf-regular/calendar-13.png',
  calendar14: 'sf-regular/calendar-14.png',
  calendar15: 'sf-regular/calendar-15.png',
  calendar16: 'sf-regular/calendar-16.png',
  calendar17: 'sf-regular/calendar-17.png',
  calendar18: 'sf-regular/calendar-18.png',
  calendar19: 'sf-regular/calendar-19.png',
  calendar20: 'sf-regular/calendar-20.png',
  calendar21: 'sf-regular/calendar-21.png',
  calendar22: 'sf-regular/calendar-22.png',
  calendar23: 'sf-regular/calendar-23.png',
  calendar24: 'sf-regular/calendar-24.png',
  calendar25: 'sf-regular/calendar-25.png',
  calendar26: 'sf-regular/calendar-26.png',
  calendar27: 'sf-regular/calendar-27.png',
  calendar28: 'sf-regular/calendar-28.png',
  calendar29: 'sf-regular/calendar-29.png',
  calendar30: 'sf-regular/calendar-30.png',
  calendar31: 'sf-regular/calendar-31.png',
}

const localIcons = {
  approve: 'local/approve.svg',
  stripeName: 'local/stripeName.svg',
  stripe: 'local/stripe.svg',
  stripe_refund: 'local/stripe.svg',
  portal: 'local/portal.svg',
  paragraph: 'local/paragraph.svg',
  header: 'local/header.svg',
  title: 'local/custom-title.svg',
  imageFilter: 'local/custom-imageFilter.svg',
  blockText: 'local/custom-text.svg',
  design: 'local/custom-design.svg',
  editPage: 'local/custom-editPage.svg',
  font: 'local/custom-font.svg',
  titleSize: 'local/custom-title-size.svg',
  // header: 'local/custom-header.svg',
  menu: 'local/custom-menu.svg',
  page: 'local/custom-page.svg',
  pages: 'local/custom-pages.svg',
  border: 'local/custom-border-width.svg',
  addPage: 'local/custom-add-page.svg',
}

const icons = {
  ...regularIcons,
  ...smallIcons,
  ...specialIcons,
  ...calendarIcons,
  ...localIcons,
}

export default icons

export type Icon = keyof typeof icons
